import type { RecordingConsentEvent } from "../../graphql/queries/OrganizationRecordingConsentEvents";
import { toCsv } from "../../utils/csv";

export function dateFilterToIso(date: string, endOfDay = false) {
  if (!date) return undefined;
  const localDate = new Date(
    `${date}T${endOfDay ? "23:59:59.999" : "00:00:00.000"}`,
  );
  return localDate.toISOString();
}

export function formatConsentTimestamp(timestamp: string) {
  return new Date(timestamp).toLocaleString();
}

export function consentEventsToCsv(events: RecordingConsentEvent[]) {
  return toCsv(
    [
      "User email",
      "Action",
      "Surface",
      "Consent text",
      "Version",
      "Source",
      "Note UUID",
      // Canonical ISO-8601 UTC value straight from the backend, so the export
      // is machine-parseable and unambiguous for audit/dispute use. The UI shows
      // a localized time; the CSV must not.
      "Received at (UTC)",
    ],
    events.map((event) => [
      event.userEmail,
      event.action,
      event.surface,
      event.consentText,
      event.consentTextVersion,
      event.source,
      event.noteUuid ?? "",
      event.createdAt,
    ]),
  );
}
